var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "story-maker",
      class: `story-maker-post-creator ${_vm.cursorName}`,
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _vm.previewEnabled
        ? _c("div", { staticClass: "lock", on: { click: _vm.toggleMuteSound } })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "overflow",
          class: { axeX: _vm.showAxe.x, axeY: _vm.showAxe.y },
          style: {
            "--z-index-axe": _vm.showAxe.index,
            backgroundColor: _vm.storySelected.background.color,
          },
        },
        [
          _vm.storySelected.removed
            ? _c("alert", {
                attrs: {
                  title: "Démasquer la story ?",
                  subTitle:
                    "Si vous démasquer cette story, elle apparaîtra lors de la publication sur la page sélectionnée.",
                  choices: [
                    {
                      content: "Démasquer",
                      warning: true,
                      cb: () => (_vm.storySelected.removed = false),
                    },
                  ],
                },
              })
            : _vm.showAlertDelete &&
              _vm.formInstance.merge.target == "main" &&
              _vm.formInstance.stories.length == 1
            ? _c("alert", {
                attrs: {
                  title: "Réinitialiser la story ?",
                  subTitle:
                    "Si vous réinitialiser cette story, vous perdrez toutes les modification que vous avez apportées",
                  choices: [
                    {
                      content: "Réinitialiser",
                      warning: true,
                      cb: _vm.handleResetStory,
                    },
                    {
                      content: "Continuer les modifications",
                      cb: () => (_vm.showAlertDelete = false),
                    },
                  ],
                },
              })
            : _vm.showAlertDelete &&
              (_vm.formInstance.merge.target == "main" ||
                _vm.storySelected.fromPersonalisation)
            ? _c("alert", {
                attrs: {
                  title: "Supprimer la story ?",
                  subTitle:
                    "Si vous supprimer cette story, vous perdrez toutes les modification que vous avez apportées",
                  choices: [
                    {
                      content: "Supprimer",
                      warning: true,
                      cb: _vm.handleDeleteStory,
                    },
                    {
                      content: "Continuer les modifications",
                      cb: () => (_vm.showAlertDelete = false),
                    },
                  ],
                },
              })
            : _vm.showAlertDelete &&
              _vm.formInstance.merge.target.id &&
              !_vm.storySelected.fromPersonalisation
            ? _c("alert", {
                attrs: {
                  title: "Masquer la story ?",
                  subTitle:
                    "Si vous masquez cette story, elle n’apparaîtra pas lors de la publication sur la page sélectionnée.",
                  choices: [
                    {
                      content: "Masquer",
                      warning: true,
                      cb: _vm.handleDeleteStory,
                    },
                    {
                      content: "Continuer les modifications",
                      cb: () => (_vm.showAlertDelete = false),
                    },
                  ],
                },
              })
            : _vm._e(),
          !_vm.overlayMode && !_vm.previewEnabled
            ? [
                _c(
                  "div",
                  {
                    staticClass: "btns-action",
                    attrs: { "data-html2canvas-ignore": "true" },
                  },
                  [
                    _vm.musicSticker ||
                    (_vm.backgroundFile &&
                      _vm.backgroundFile.info.type2 == "video")
                      ? _c("div", {
                          staticClass: "btn sound",
                          class: { muted: _vm.mutedSound },
                          on: { click: _vm.toggleMuteSound },
                        })
                      : _vm._e(),
                    _vm.formInstance.merge.target.id &&
                    _vm.formInstance.merge.target.isNative
                      ? _c("ButtonHighlight", {
                          attrs: {
                            storySelected: _vm.storySelected,
                            formInstance: _vm.formInstance,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setOverlay("highlight")
                            },
                          },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "btn text", on: { click: _vm.addText } },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/instagram/icon_story_text.png"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btn stickers",
                        on: {
                          click: function ($event) {
                            return _vm.setOverlay("stickers")
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/instagram/icon_story_sticker.png"),
                          },
                        }),
                      ]
                    ),
                    _vm.pagesSelectedIncludeConciergerie
                      ? _c(
                          "Tooltip",
                          {
                            attrs: {
                              active: !!_vm.musicSticker,
                              text:
                                !!_vm.musicSticker &&
                                (_vm.musicSticker.data.music.track
                                  ? _vm.musicSticker.data.music.track.title
                                  : _vm.musicSticker.data.music.original_sound
                                      .title),
                              position: "bottom",
                              classCustom: "btn music",
                            },
                            on: {
                              click: () => {
                                _vm.musicSticker
                                  ? (this.stickerSelected = _vm.musicSticker)
                                  : _vm.setOverlay("stickers-musicMenu")
                              },
                            },
                          },
                          [
                            _vm.musicSticker
                              ? _c("img", {
                                  staticClass: "thumbnail-music",
                                  attrs: {
                                    src: _vm.musicSticker.data.music.track
                                      ? _vm.musicSticker.data.music.track
                                          .cover_artwork_thumbnail_uri
                                      : _vm.musicSticker.data.music
                                          .original_sound.ig_artist
                                          .profile_pic_url,
                                  },
                                })
                              : _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/instagram/icon_story_music.png"),
                                  },
                                }),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "btn delete-story",
                    attrs: { "data-html2canvas-ignore": "true" },
                    on: { click: _vm.handleDeleteStory },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/instagram/instagram_x_outline_44.png"),
                      },
                    }),
                  ]
                ),
              ]
            : !_vm.previewEnabled &&
              _vm.overlayMode &&
              (_vm.overlayMode.slice(0, 8) == "stickers" ||
                _vm.overlayMode == "backgroundResize")
            ? _c("div", { staticClass: "btns-action" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn cancel",
                    on: { click: _vm.closeOverlay },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/instagram/instagram_x_outline_44.png"),
                      },
                    }),
                  ]
                ),
              ])
            : _vm._e(),
          _vm.overlayMode == "backgroundResize" &&
          _vm.storySelected.background.file
            ? _c(
                "div",
                { staticClass: "btn-background-resize" },
                [
                  _vm.storySelected.background.file.info.aspectRatio > 0.5625
                    ? [
                        _c("i", {
                          staticClass:
                            "fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center",
                          staticStyle: { transform: "rotate(45deg)" },
                          on: {
                            click: function ($event) {
                              return _vm.storySelected.background.setSize(
                                "containX"
                              )
                            },
                          },
                        }),
                        _c("i", {
                          staticClass:
                            "fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center",
                          on: {
                            click: function ($event) {
                              return _vm.storySelected.background.setSize(
                                "containY"
                              )
                            },
                          },
                        }),
                      ]
                    : [
                        _c("i", {
                          staticClass:
                            "fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center",
                          staticStyle: { transform: "rotate(135deg)" },
                          on: {
                            click: function ($event) {
                              return _vm.storySelected.background.setSize(
                                "containY"
                              )
                            },
                          },
                        }),
                        _c("i", {
                          staticClass:
                            "fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center",
                          on: {
                            click: function ($event) {
                              return _vm.storySelected.background.setSize(
                                "containX"
                              )
                            },
                          },
                        }),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm.onStickerDrag
            ? _c(
                "div",
                {
                  staticClass: "trash-stiker",
                  class: { active: _vm.trashIsHover },
                  on: {
                    mouseover: function ($event) {
                      _vm.trashIsHover = true
                    },
                    mouseleave: function ($event) {
                      _vm.trashIsHover = false
                    },
                  },
                },
                [_c("div", { staticClass: "icon" })]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "container-bg-story",
              class: { edit: _vm.overlayMode == "backgroundResize" },
            },
            [
              _c(
                "draggable",
                {
                  attrs: {
                    position: _vm.storySelected.background.position,
                    transform: _vm.storySelected.background.transform,
                    classCustom: _vm.storySelected.background.size,
                    disableTransform: _vm.overlayMode !== "backgroundResize",
                    disableMove: _vm.overlayMode !== "backgroundResize",
                  },
                  on: { setStoryMakerCursor: _vm.setCursor },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "bg-story selectDisable",
                      class: _vm.storySelected.background.size,
                    },
                    [
                      _vm.storySelected.background.file
                        ? [
                            _vm.storySelected.background.file.info.type.startsWith(
                              "image/"
                            )
                              ? _c("img", {
                                  staticClass: "selectDisable",
                                  attrs: {
                                    src: _vm.storySelected.background.file.url,
                                    draggable: "false",
                                  },
                                })
                              : _vm.storySelected.background.file.info.type.startsWith(
                                  "video/"
                                )
                              ? _c("video", {
                                  ref: "video",
                                  staticClass: "source",
                                  attrs: {
                                    src: _vm.storySelected.background.file.url,
                                    type: _vm.storySelected.background.file.info
                                      .type,
                                    onloadedmetadata: "true",
                                    preload: "metadata",
                                    autoplay: "",
                                    loop: "",
                                    playsinline: "",
                                  },
                                  domProps: {
                                    muted: _vm.mutedSound || _vm.musicSticker,
                                  },
                                  on: { timeupdate: _vm.videoCheckLoop },
                                })
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.overlayMode !== "backgroundResize"
            ? _vm._l(
                _vm.storySelected.stickers.items,
                function (sticker, index) {
                  return _c("draggable", {
                    key: sticker.id,
                    attrs: {
                      position: sticker.position,
                      transform: sticker.transform,
                      zIndex: 100 + index,
                      classCustom: `story-maker-draggable-sticker ${sticker.type} id-${index} ${sticker.data.text}`,
                      isSelected:
                        _vm.stickerSelected &&
                        _vm.stickerSelected.id == sticker.id,
                      disableTransform: sticker.disableTransform,
                      disableMove: sticker.disableMove,
                      disableDelete: sticker.disableDelete,
                      disableIncreaseZIndex: sticker.disableIncreaseZIndex,
                      trashIsHover: _vm.trashIsHover,
                    },
                    on: {
                      deleteSticker: sticker.delete,
                      increaseZIndex: sticker.bringToFront,
                      click: () => _vm.selectSticker(sticker),
                      setDragState: (state) => {
                        _vm.onStickerDrag = state
                        _vm.trashIsHover = false
                      },
                      setStoryMakerCursor: _vm.setCursor,
                      setShowAxe: _vm.setShowAxe,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({
                            setCover,
                            setCbClick,
                            isPreventCover,
                            isCover,
                          }) {
                            return [
                              _c("stickerWrapper", {
                                attrs: {
                                  sticker: sticker,
                                  isPreventCover: isPreventCover,
                                  isCover: isCover,
                                  setCover: setCover,
                                  setCbClick: setCbClick,
                                  files: _vm.files,
                                  previewEnabled: _vm.previewEnabled,
                                  pageSelected: _vm.pageSelected,
                                  stickerInstance: sticker,
                                  story: _vm.storySelected,
                                  isSelected:
                                    _vm.stickerSelected &&
                                    _vm.stickerSelected.id == sticker.id,
                                },
                                on: {
                                  unselect: _vm.unselectSticker,
                                  select: function ($event) {
                                    return _vm.selectSticker(sticker)
                                  },
                                  deleteSticker: sticker.delete,
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }
              )
            : _vm._e(),
          _vm.overlayMode && _vm.overlayMode.split("-")[0] == "stickers"
            ? _c("StickerMenu", {
                attrs: {
                  menuNameDefault: _vm.overlayMode.split("-")[1],
                  dataInstagramDefault: _vm.dataInstagramDefault,
                  stickers: _vm.storySelected.stickers,
                  pagesSelectedIncludeConciergerie:
                    _vm.pagesSelectedIncludeConciergerie,
                },
                on: { addSticker: _vm.addSticker, close: _vm.closeOverlay },
              })
            : _vm.overlayMode && _vm.overlayMode == "highlight"
            ? _c("HighlightMenu", {
                attrs: {
                  formInstance: _vm.formInstance,
                  storySelected: _vm.storySelected,
                  highlights: _vm.highlightsPage[_vm.pageSelected.id]
                    ? _vm.highlightsPage[_vm.pageSelected.id]
                    : null,
                  files: _vm.files,
                },
                on: { close: _vm.closeOverlay },
              })
            : _vm._e(),
        ],
        2
      ),
      _vm.musicSticker
        ? _c("audio", {
            ref: "audio",
            attrs: {
              src: (
                _vm.musicSticker.data.music.track ||
                _vm.musicSticker.data.music.original_sound
              ).fast_start_progressive_download_url,
              autoplay: "",
              loop: "",
            },
            on: {
              loadedmetadata: _vm.setStartMusic,
              timeupdate: _vm.checkTimeMusic,
              canplaythrough: (e) =>
                (e.target.volume = _vm.mutedSound ? "0" : "0.5"),
            },
          })
        : _vm._e(),
      _vm.previewEnabled &&
      (_vm.musicSticker ||
        (_vm.backgroundFile && _vm.backgroundFile.info.type2 == "video"))
        ? _c("div", {
            key: _vm.mutedSound ? "no-sound" : "sound",
            class: _vm.mutedSound ? "no-sound" : "sound",
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }